// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1zaSK","title":"Info_title__rh0Ue","links":"Info_links__3TH2R","link":"Info_link__1bG8Y","logo":"Info_logo__2LHKn"};